import { RootState } from "../../reducers";

export const recentMappedDocumentIdSelector = (state: RootState): string =>
  state.overridesScreen.recentMappedDocumentId;
